import { useParams } from "react-router-dom";
import { useTenantDetail } from "@/api/tenants";

export function useTenantContext() {
  const { tenantId } = useParams<{ tenantId: string }>();
  const { data: tenant, isLoading } = useTenantDetail(tenantId || "");
  return { tenantId: tenantId || "", tenant: tenant ?? null, isLoading };
}
